import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import KYCBanner from 'components/KYCBanner';

const SellerPaiement = () => {
  const [user, setUser] = useState(null);
  const [dashboardMagicLink, setDashboardMagicLink] = useState(null);

  const initDashboardMagicLink = () => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    };
    axios
      .get(`${CONFIG.apiUrl}/stripe/dashboard`, config)
      .then(res => {
        setDashboardMagicLink(res.data.url);
      })
      .catch(err => {
        console.log('Impossible to prepare KYC process', err);
      });
  };

  const initUser = () => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    };
    axios
      .get(`${CONFIG.apiUrl}/user/me`, config)
      .then(res => {
        setUser(res.data);
        if (res.data && res.data.type !== 'seller') {
          window.location.href = '/my-request';
        }
      })
      .catch(err => {
        console.log('No user info found', err);
      });
  };

  useEffect(() => {
    if (
      !localStorage.getItem('token') ||
      localStorage.getItem('token').length < 10
    )
      window.location.href = '/auth/sign-up';
    initUser();
    initDashboardMagicLink();
  }, []);

  return (
    <div className="flex flex-col gap-6">
      <KYCBanner user={user} onUserRefresh={initUser} />
      <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
        <div className="flex flex-col items-center text-center">
          <p className="font-geist text-sm font-semibold text-leadrs-text">
            Accedez a votre compte vendeur Stripe
          </p>
          <p className="mt-2 font-geist text-sm text-leadrs-text-soft">
            Notre partenaire Stripe vous permet de visualiser vos ventes et recevoir vos paiements directement sur votre compte bancaire.
          </p>
          <div className="mt-6">
            {user && dashboardMagicLink ? (
              <button
                className="rounded-lg bg-leadrs-brand px-5 py-2.5 font-geist text-sm font-medium text-white transition-opacity hover:opacity-80"
                onClick={() => (window.location.href = dashboardMagicLink)}
              >
                Acceder a mon dashboard
              </button>
            ) : (
              <p className="font-geist text-sm text-leadrs-text-soft">
                Vous devez valider votre compte et remplir vos KYC pour acceder a votre dashboard.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerPaiement;
